import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Lookup } from '@app/modules/lookup/models/lookup.model';
import { LookupService } from '@app/modules/lookup/services/lookup.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import moment from 'moment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordStockPurchasePlan } from '../../models/employment-record-stock-purchase-plan.model';
import { EmploymentRecordStockPurchasePlanService } from '../../services/employment-record-stock-purchase-plan.service';

@Component({
  selector: 'app-employment-record-stock-purchase-plan-dialog',
  templateUrl: './employment-record-stock-purchase-plan-dialog.component.html',
  styleUrls: ['./employment-record-stock-purchase-plan-dialog.component.scss']
})
export class EmploymentRecordStockPurchasePlanDialogComponent implements OnInit {
  form: UntypedFormGroup;
  employmentRecordId: any;
  employeeId: any;
  stockPurchasePlanId: any;
  isLoading: boolean;
  employmentRecordStockPurchasePlan: EmploymentRecordStockPurchasePlan;
  employerContributionPercentageOptions: Observable<Lookup[]>;
  divisionOptions: Observable<Lookup[]>;
  memberOptions: Observable<Lookup[]>;

  constructor(
    private fb: UntypedFormBuilder,
    private lookupService: LookupService,
    private overlayService: OverlayService,
    private employmentRecordStockPurchasePlansService: EmploymentRecordStockPurchasePlanService,
    private snackbarService: SnackbarService,
    private dialogRef: MatDialogRef<EmploymentRecordStockPurchasePlanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.employmentRecordId = data.employmentRecordId;
    this.employeeId = data.employeeId;
    this.stockPurchasePlanId = data.StockPurchasePlanId;
  } 

  ngOnInit(): void {
    this.getLookups();

    this.stockPurchasePlanId !== null 
      ? this.getEmploymentRecordStockPurchasePlan() 
      : this.isLoading = false; 
        this.createForm();
  }

  getEmploymentRecordStockPurchasePlan() {
    this.isLoading = true;
    
    this.employmentRecordStockPurchasePlansService.getStockPurchasePlan(this.employeeId, this.employmentRecordId, this.stockPurchasePlanId)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe(
      res => {
        this.employmentRecordStockPurchasePlan = res;
        this.createForm();
      }
    );
  }

  getLookups() {
    this.employerContributionPercentageOptions = this.lookupService.getLookups("/lookup/STOCK_PURCHASE_EMPLOYER_CONTRIBUTION_PERCENT");
    this.divisionOptions = this.lookupService.getLookups("/lookup/STOCK_PURCHASE_DIVISION");
    this.memberOptions = this.lookupService.getLookups("/lookup/STOCK_PURCHASE_MEMBER");
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.employmentRecordStockPurchasePlan ? this.employmentRecordStockPurchasePlan.id : null],
      effectiveDate: [moment().format()],
      member: [this.employmentRecordStockPurchasePlan && this.employmentRecordStockPurchasePlan.member ? this.employmentRecordStockPurchasePlan.member.id : null],
      division: [this.employmentRecordStockPurchasePlan && this.employmentRecordStockPurchasePlan.division ? this.employmentRecordStockPurchasePlan.division.id : null],
      employerContributionPercentage: [this.employmentRecordStockPurchasePlan && this.employmentRecordStockPurchasePlan.employerContributionPercentage ? this.employmentRecordStockPurchasePlan.employerContributionPercentage.id : null],
      employeeContributionPercentage: [this.employmentRecordStockPurchasePlan ? this.employmentRecordStockPurchasePlan.employeeContributionPercentage : null],
      employeeVoluntaryPercentage: [this.employmentRecordStockPurchasePlan ? this.employmentRecordStockPurchasePlan.employeeVoluntaryPercentage : null],
      enrollmentDate: [this.employmentRecordStockPurchasePlan ? this.employmentRecordStockPurchasePlan.enrollmentDate : null],
      comments: [this.employmentRecordStockPurchasePlan ? this.employmentRecordStockPurchasePlan.comments : null],
      changeReason: [''],
      changeReasonComments: ['']
    });
  }

  save(){
    this.overlayService.show();

    this.employmentRecordStockPurchasePlansService.postStockPurchasePlan(this.employeeId, this.employmentRecordId, this.form.value)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.snackbarService.openSnackBar('Stock Purchase Plan saved successfully', 'clear', 'success');
        this.dialogRef.close(true);
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  close(){
    this.dialogRef.close();
  }

}

